// import React from "react";
// import VISASERVICES from "../../assets/images/visaservices.jpeg";
// import CRUISETOURS from "../../assets/images/cruisetours.jpeg";
// import AIRTICKETS from "../../assets/images/airtickets.jpeg";
// import HOTELBOOKINGS from "../../assets/images/hotelbookings.jpeg";
// import DOMESTICTOURS from "../../assets/images/domestictours.jpeg";
// import INTERNATIONALTOURS from "../../assets/images/internationaltours.jpeg";
// import COUPLETOURS from "../../assets/images/coupletours.jpeg";
// import ADVENTURETOURS from "../../assets/images/adventuretours.jpeg";
// import WILDLIFETOURS from "../../assets/images/wildlifetours.jpeg";
// import BEACHTOURS from "../../assets/images/beachtours.jpeg";
// import CORPORATETOURS from "../../assets/images/corporatetours.jpeg";
// import DESTINATIONWEDDING from "../../assets/images/destinationwedding.jpeg";
import Slider from "react-slick";
import WeekendCard from "./WeekendCard";
import { useAppSelector } from "../../app/hooks";

// const weekendDeals = [
//   {
//     image: CRUISETOURS,
//     name: "Cruise Tours",
//   },
//   {
//     image: AIRTICKETS,
//     name: "Air TIckets",
//   },
//   {
//     image: HOTELBOOKINGS,
//     name: "Hotel Bookings",
//   },
//   {
//     image: DOMESTICTOURS,
//     name: "Domestic Tours",
//   },
//   {
//     image: INTERNATIONALTOURS,
//     name: "International Tours",
//   },
//   {
//     image: COUPLETOURS,
//     name: "Couple Tours",
//   },
//   {
//     image: ADVENTURETOURS,
//     name: "Adventure Tours",
//   },
//   {
//     image: WILDLIFETOURS,
//     name: "Wildlife Tours",
//   },
//   {
//     image: BEACHTOURS,
//     name: "Beach Tours",
//   },
//   {
//     image: CORPORATETOURS,
//     name: "Corporate Tours",
//   },
//   {
//     image: DESTINATIONWEDDING,
//     name: "Destination Wedding",
//   },
//   {
//     image: VISASERVICES,
//     name: "Visa Services",
//   },
// ];

const WeekendDeals = () => {
  const services = useAppSelector((state) => state.home.services);
  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 2000,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="lastdeal-section mt-5 mb-5">
      <div className="container">
        <h2 className="text-start mb-3 mt-2 ps-2">Our Services</h2>
        <p className="ps-2">
          Exceptional Travel Services, Crafted Just for You
        </p>
        <Slider {...settings}>
          {services?.map((service: any, index: any) => (
            <WeekendCard key={index} service={service} />
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default WeekendDeals;
